/* eslint-disable no-async-promise-executor */
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import 'moment/locale/fr'
import moment from 'moment-timezone'
import { getSecureDocument } from '../../api/hds'
import {
    HISTORY_REMINDER_FETCH,
    HISTORY_SYNTHESIS_LOADING,
    HISTORY_SYNTHESIS_LOADED,
    HISTORY_ALERT_DISPLAY,
    HISTORY_ALERT_HIDE,
} from './types'
import { appendAndTriggerPdfDownloadLink } from '../../utils/utils'

/**
 *
 *
 * @param {*} localUrl
 * @param {*} fileName
 */
function downloadFromLocal(localUrl: any, fileName: any) {
    appendAndTriggerPdfDownloadLink(localUrl, fileName)
}

export const getSynthesisDocument = (uid: any) => async (dispatch: any) => {
    try {
        dispatch({
            type: HISTORY_SYNTHESIS_LOADING,
        })
        let localUrl = ''
        try {
            const url = `${window._env_.REACT_APP_PDF_HOST}/synthesis`
            // @ts-expect-error TS(2322) FIXME: Type 'unknown' is not assignable to type 'string'.
            localUrl = await getSecureDocument(url)
        } catch (error) {
            dispatch({
                type: HISTORY_SYNTHESIS_LOADED,
            })
            dispatch({
                type: HISTORY_ALERT_DISPLAY,
                payload: (error as any).message,
            })
            return
        }
        const User = await ToktokdocLib.User.findOne(uid)
        const fullName = User.getFullName()
        const fileName = `${fullName}-${moment().format('DD/MM/YYYY à HH:mm')}-relevé trimensuel.pdf`
        downloadFromLocal(localUrl, fileName)
        dispatch({
            type: HISTORY_SYNTHESIS_LOADED,
        })
    } catch (error) {
        dispatch({
            type: HISTORY_SYNTHESIS_LOADED,
        })
        console.error(
            `[getSynthesisDocument] Error while fetching synthesis document | required expert id : ${uid} message : ${
                (error as any).message
            }`,
        )
    }
}

export const fetchHistoryTechnicalConfig = (uid: any) => async (dispatch: any) => {
    try {
        const User = ToktokdocLib.User.instance(uid)
        const technicalConfig = await User.getTechnicalConfig()
        const TechnicalConfig = await ToktokdocLib.UserTechnicalConfig.findOne(technicalConfig.objectId)
        const reminder = await TechnicalConfig.isReminderActivated()
        dispatch({
            type: HISTORY_REMINDER_FETCH,
            payload: reminder,
        })
    } catch (error) {
        console.error(
            `[fetchHistoryTechnicalConfig] Error catched | required expert id : ${uid} | message : ${
                (error as any).message
            } `,
        )
    }
}

export const updateHistoryTechnicalConfig = (uid: any, isReminderToggled: any) => async (dispatch: any) => {
    try {
        const User = ToktokdocLib.User.instance(uid)
        const technicalConfig = await User.getTechnicalConfig()
        const TechnicalConfig = await ToktokdocLib.UserTechnicalConfig.findOne(technicalConfig.objectId)
        await TechnicalConfig.setReminder(isReminderToggled)
        dispatch({
            type: HISTORY_REMINDER_FETCH,
            payload: isReminderToggled,
        })
    } catch (error) {
        console.error(
            `[updateHistoryTechnicalConfig] Error catched | required expert id : ${uid} | new reminder : ${
                isReminderToggled ? 'activated' : 'deactivated'
            }  message : ${(error as any).message}`,
        )
    }
}

export const displayAlert = (message: any) => (dispatch: any) => {
    dispatch({
        type: HISTORY_ALERT_DISPLAY,
        payload: message,
    })
}

export const hideAlert = () => (dispatch: any) => {
    dispatch({
        type: HISTORY_ALERT_HIDE,
    })
}
